import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { FieldDropdown } from '@/components/form'

const PriceFrequencyField = ({ disabled }) => {
  const { t } = useTranslation()
  const { setFieldValue } = useFormikContext()

  const handleChange = () => {
    setFieldValue('price_date_description', '')
  }

  return (
    <FieldDropdown
      name="price_frequency"
      placeholder={t('l.contract.edit.payment_freq.label', 'Payment frequency')}
      required
      disabled={disabled}
      options={[
        {
          value: 'daily',
          label: t('common.frequency_daily', 'Daily')
        },
        {
          value: 'weekly',
          label: t('common.frequency_weekly', 'Weekly')
        },
        {
          value: 'monthly',
          label: t('common.frequency_monthly', 'Monthly')
        }
      ]}
      onChange={e => handleChange(e)}
    />
  )
}

export default PriceFrequencyField
